import { c as _c } from "react/compiler-runtime";
import React from 'react';
import LabeledSelectBox from 'components/consumer/LabeledSelectBox';
import MobileOnly from 'components/consumer/MobileOnly';
import TabletAndDesktopOnly from 'components/consumer/TabletAndDesktopOnly';
import useAdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/useAdvancedSearchContext';
import { SORT_ORDER_TO_ALGOLIA_INDEX, ALGOLIA_INDEX_TO_SORT_ORDER } from 'commons/constants';
const ProductListingSortBy = t0 => {
  const $ = _c(16);
  const {
    sortByOptions: t1,
    defaultProductIndex: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const sortByOptions = t3;
  const defaultProductIndex = t2 === undefined ? SORT_ORDER_TO_ALGOLIA_INDEX.featured : t2;
  const {
    currentProductIndex,
    updateCurrentProductIndex
  } = useAdvancedSearchContext();
  let t4;
  if ($[2] !== defaultProductIndex || $[3] !== updateCurrentProductIndex) {
    t4 = e => {
      const updatedValue = e?.target?.value;
      updateCurrentProductIndex(SORT_ORDER_TO_ALGOLIA_INDEX?.[updatedValue] ?? defaultProductIndex);
    };
    $[2] = defaultProductIndex;
    $[3] = updateCurrentProductIndex;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleChange = t4;
  const t5 = ALGOLIA_INDEX_TO_SORT_ORDER[currentProductIndex];
  let t6;
  if ($[5] !== handleChange || $[6] !== sortByOptions || $[7] !== t5) {
    t6 = <MobileOnly><LabeledSelectBox className="md:hidden" label="Sort by" options={sortByOptions} value={t5} showBlankOption={false} showSingleLineLabelOverlay={true} noMargin={true} size="xs" onChange={handleChange} /></MobileOnly>;
    $[5] = handleChange;
    $[6] = sortByOptions;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = ALGOLIA_INDEX_TO_SORT_ORDER[currentProductIndex];
  let t8;
  if ($[9] !== handleChange || $[10] !== sortByOptions || $[11] !== t7) {
    t8 = <TabletAndDesktopOnly><LabeledSelectBox className="max-[767px]:hidden" label="Sort by" options={sortByOptions} value={t7} showBlankOption={false} showSingleLineLabelOverlay={true} noMargin={true} size="sm" onChange={handleChange} /></TabletAndDesktopOnly>;
    $[9] = handleChange;
    $[10] = sortByOptions;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t8) {
    t9 = <div className="w-full max-w-[215px] md:min-w-[16rem]">{t6}{t8}</div>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
export default ProductListingSortBy;